import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiMailMessage } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiMailMessageDialogData {
  mail_messages?: ApiMailMessage[];
}

@Component({
  selector: 'app-multi-mail-message-dialog',
  templateUrl: './multi-mail-message-dialog.component.html',
  styleUrls: ['./multi-mail-message-dialog.component.css'],
  standalone: false,
})
export class MultiMailMessageDialogComponent implements OnInit {

  //FAQ×言語数
  mailMessages: ApiMailMessage[] = [];
  mailMessagesFormGroup!: FormGroup;
  mailMessagesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiMailMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiMailMessageDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.mailMessages = this.data.mail_messages!;
    if (!this.mailMessages) {
      this.mailMessages = [];
    }
    this.currentLang = this.translate.currentLang;
    this.createForm();
    this.mailMessagesArrayControl = this.mailMessagesFormGroup.get('mailMessages') as FormArray;
  }

  //FAQフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.mailMessages.length ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let mail_message = '';
      let trans_mail_message = '';
      for (const value of this.mailMessages) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          mail_message = value.mail_message;
          trans_mail_message = value.trans_mail_message;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          mailMessage: [mail_message],
          transMailMessage: [trans_mail_message],
        }
      ));
      index++;
    }
    this.mailMessagesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        mailMessages: arrayControl
      }
    );
  }

  //更新ボタン
  addMailMessages(): void {
    if (this.mailMessagesFormGroup.valid) {
      let mailMessages = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.mailMessagesArrayControl.controls[index];
        mailMessages.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            mail_message: ctrl.get('mailMessage')!.value,
            trans_mail_message: ctrl.get('transMailMessage')!.value,
          }
        )
      }
      this.mailMessages = mailMessages;
      this.dialogRef.close(this.mailMessages);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.mailMessagesFormGroup.get('autoAllTrans')!.value;
    for (const mailMessage of this.mailMessagesArrayControl.controls) {
      mailMessage.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.mailMessagesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const mailMessage of this.mailMessagesArrayControl.controls) {
      if (!mailMessage.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.mailMessagesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
